import { JobRequest } from "./job-request";
export interface PlanRevisionRequest {
    planId: string;
    connectionId: string;
    jobRequestDtos: JobRequest[];
}